import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import api from '../../api/axios/foka'
import { failWithErrorResponse } from '../toast/Toast'
import { ReviewTargetType } from '../Codes'

export const ReviewTargetFetchers = {
  BIZCHANNEL: api.channel.getReviewReason,
  CREATIVE: api.creative.getReviewReason,
  KEYWORD: api.ad.getKeywordReviewReason,
  KEYWORD_LANDING_URL: api.ad.getKeywordReviewReason,
}

const initialState = {
  visible: false,
  isLoading: false,
  showSubtitle: false,
  reviewTargetType: ReviewTargetType.BIZCHANNEL,
  reasons: undefined,
}

export const showReviewReason = createAsyncThunk(
  'reviewReason/showReviewReason',
  async ({ id, reviewTargetType }, { rejectWithValue }) => {
    const fetcher = ReviewTargetFetchers[reviewTargetType.name]
    try {
      const { data } = await fetcher(id)
      return data.response
    } catch (error) {
      failWithErrorResponse(error?.response?.data)
      return rejectWithValue()
    }
  }
)
const reviewReasonSlice = createSlice({
  name: 'reviewReason',
  initialState,
  reducers: {
    hideReviewReason: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(
      showReviewReason.pending,
      (
        state,
        {
          meta: {
            arg: { reviewTargetType, showSubtitle },
          },
        }
      ) => {
        state.isLoading = true
        state.reviewTargetType = reviewTargetType
        state.showSubtitle = showSubtitle || false
      }
    )
    builder.addCase(showReviewReason.fulfilled, (state, { payload }) => {
      state.reasons = payload
      state.isLoading = false
      state.visible = true
    })
    builder.addCase(showReviewReason.rejected, state => {
      state.isLoading = false
      state.visible = false
    })
  },
})
export const { hideReviewReason } = reviewReasonSlice.actions
export default reviewReasonSlice.reducer
